import React from 'react';
import { Link } from 'react-router-dom';

const Services = () => {
  const services = [
    {
      title: "Window Cleaning",
      description: "Professional residential and commercial window cleaning — interior and exterior.",
      image: "https://customer-assets-v7afamib.emergentagent.net/job_034ba03a-ab9b-460a-8d65-ab113159d799/artifacts/lf1m7ks6_window%20squigi.webp",
      alt: "Residential and commercial interior and exterior window cleaning in the Hamptons",
      link: "/services/window-cleaning"
    },
    {
      title: "House & Roof Washing",
      description: "Safe residential and commercial house and roof washing with our soft-wash system — removes moss, streaks, and algae.",
      image: "https://customer-assets.emergentagent.com/job_clean-hamptons-demo/artifacts/90x60b57_Powerwashing%20Photo.png",
      alt: "Professional house and roof washing for siding, brick, stucco, and roofs",
      link: "/services/house-washing"
    },
    {
      title: "Interior Cleaning",
      description: "Maintenance cleaning, seasonal deep cleans, home organizing, and laundry services.",
      image: "https://customer-assets.emergentagent.com/job_034ba03a-ab9b-460a-8d65-ab113159d799/artifacts/wfvkuq7j_istockphoto-1480372898-612x612.jpg",
      alt: "Professional interior house cleaning and maintenance services",
      link: "/services/interior-cleaning"
    },
    {
      title: "Gutter Cleaning",
      description: "Residential & commercial gutter cleaning — prevents water damage and leaks.",
      image: "/images/services/gutter-cleaning.jpg",
      alt: "Professional gutter cleaning services removing leaves, debris, and clogs",
      link: "/services/gutter-cleaning"
    },
    {
      title: "Commercial Cleaning",
      description: "Professional window cleaning and power washing for offices, storefronts, and commercial properties.",
      image: "https://customer-assets-v7afamib.emergentagent.net/job_034ba03a-ab9b-460a-8d65-ab113159d799/artifacts/bf3alczn_Screenshot%202026-08-17%20at%2011.21.05%E2%80%AFAM.png",
      alt: "Commercial window cleaning and exterior services for businesses",
      link: "/services/commercial-cleaning"
    },
    {
      title: "Shrink Wrapping",
      description: "Seasonal shrink wrapping for boats, furniture, and equipment.",
      image: "https://customer-assets.emergentagent.com/job_clean-hamptons-demo/artifacts/op2yw6sf_Shrink%20Wrapping%206.png",
      alt: "Seasonal shrink wrapping for outdoor furniture, boats, and equipment",
      link: "/services/shrink-wrapping"
    }
  ];

  return (
    <section id="services" className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Our Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            15 years of comprehensive cleaning solutions for your home and business
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <Link
              to={service.link}
              key={index}
              className="group relative bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer"
              data-testid={`service-card-${index}`}
            >
              {/* Image */}
              <div className="relative h-64 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.alt}
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                
                {/* Title overlay */}
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="text-2xl font-bold text-white mb-2">
                    {service.title}
                  </h3>
                </div>
              </div>

              {/* Description */}
              <div className="p-6">
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>
                <span className="inline-block mt-4 text-blue-600 font-semibold group-hover:text-blue-700">
                  Learn More →
                </span>
              </div>

              {/* Hover accent */}
              <div className="absolute top-0 right-0 w-20 h-20 bg-blue-600 rounded-bl-full opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
